<template>
  <el-dialog
    :model-value="visible"
    :title="title"
    width="90%"
    top="5vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    class="responsive-modal"
    @close="cerrarModal"
  >
    <div class="modal-content">
      <slot />
    </div>
  </el-dialog>
</template>

<script setup>
defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Modal',
  },
});

const emit = defineEmits(['cerrar-modal']);

const cerrarModal = () => {
  emit('cerrar-modal');
};
</script>

<style scoped>
.modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

:deep(.responsive-modal) {
  .el-dialog {
    max-height: 90vh;
    margin-top: 5vh !important;
    margin-bottom: 5vh !important;
    display: flex;
    flex-direction: column;
  }

  .el-dialog__header {
    flex-shrink: 0;
    border-bottom: 1px solid #e4e7ed;
  }

  .el-dialog__body {
    flex: 1;
    overflow-y: auto;
    padding: 0;
    max-height: calc(90vh - 120px);
  }
}

/* Responsive para pantallas más pequeñas */
@media (max-width: 768px) {
  :deep(.responsive-modal) {
    .el-dialog {
      width: 95% !important;
      margin: 2vh auto !important;
      max-height: 96vh;
    }

    .el-dialog__body {
      max-height: calc(96vh - 100px);
    }
  }
}

@media (max-height: 600px) {
  :deep(.responsive-modal) {
    .el-dialog {
      margin: 1vh auto !important;
      max-height: 98vh;
    }

    .el-dialog__body {
      max-height: calc(98vh - 80px);
    }
  }
}
</style>
